import axios from "axios";
//Url del serivicio rest principal
let apiURL = process.env.REACT_APP_SERVER_URL;
//Crea una instancia de objeto axios
const instance = axios.create({
  baseURL: apiURL,
});

//Establece la configuración para interceptar errores
export function SetupServiceNetwork(store) {
  instance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (
        error.response?.data?.errors[0]?.message ===
          "Context creation failed: jwt expired" ||
        error.response?.data?.errors[0]?.message ===
          "Context creation failed: jwt malformed"
      ) {
        debugger;

        console.log(error.response.config.data);
      }
      if (error.response && error.response.data) {
        return Promise.reject(error.response.data);
      }
      return Promise.reject(error.message);
    }
  );
}

export default instance;
